import MapControlPopover from '../MapControlPopover';

import ApplyIcon from 'components/icons/ApplyIcon';
import NoEntryIcon from 'components/icons/NoEntryIcon';

import useTranslation from './hooks/useTranslation';

import { DISPLAY_ICON_TEST_ID, DRAWING_MODE, LABEL_ICON_TEST_ID, TEST_ID } from './constants';
import type { DrawingModeIcons, DrawingModeLabels, Props } from './types';

const DRAWING_MODE_ICON: DrawingModeIcons = {
    [DRAWING_MODE.APPLY]: ApplyIcon,
    [DRAWING_MODE.NO_ENTRY]: NoEntryIcon
};

const DrawingModeDropdown = ({ drawingMode, onDrawingModeChange, testId = TEST_ID }: Props) => {
    const { APPLY, NO_ENTRY } = useTranslation();

    const Icon = DRAWING_MODE_ICON[drawingMode];

    const drawingModeLabels: DrawingModeLabels = {
        [DRAWING_MODE.APPLY]: APPLY,
        [DRAWING_MODE.NO_ENTRY]: NO_ENTRY
    };

    const options = [
        { label: APPLY, value: DRAWING_MODE.APPLY },
        { label: NO_ENTRY, value: DRAWING_MODE.NO_ENTRY }
    ];

    return (
        <MapControlPopover
            displayText={
                <>
                    <Icon testId={LABEL_ICON_TEST_ID} />

                    {drawingModeLabels[drawingMode]}
                </>
            }
            displayIcon={<Icon testId={DISPLAY_ICON_TEST_ID} />}
            onChange={onDrawingModeChange}
            options={options}
            testId={testId}
            value={drawingMode}
        />
    );
};

export default DrawingModeDropdown;
